module.exports = __webpack_public_path__ + "static/media/features-richmedia-gray.f22c031a.png";